import React from "react";
import useAppContext from "../../../context/useAppContext";
import EmptyStateWrapper from "../../../shared/EmptyStateWrapper";
import { isBillingPlanFreeLaunch } from "../../settings/billing/BillingUtils";
import { UserType } from "../../../../models/Entities";

/**
 * Creates a row with an empty state in it for any empty state
 */
const EmptyState = () => {
  const { user, isUserPrivileged } = useAppContext();
  const privilegedRoles = new Set([
    UserType.admin_with_billing,
    UserType.admin_without_billing,
    UserType.support,
  ]);
  const showPrivillaged = privilegedRoles.has(user.type);

  return (
    <tr>
      <td colSpan={10} className="py-9">
        <EmptyStateWrapper
          title={
            showPrivillaged
              ? "No recent activity"
              : "You must be an admin, developer, or support to view activity"
          }
          subtitle={
            showPrivillaged
              ? `Logs are retained for ${
                  isBillingPlanFreeLaunch(user.organization.organization_billing_plan?.billing_plan)
                    ? 3
                    : 7
                } days`
              : undefined
          }
        />
      </td>
    </tr>
  );
};

export default EmptyState;
